import { ExportServerConfig } from '@/modules/core/export/models/ExportServerConfig';
import { ReportStudioTemplate } from '@/modules/ta/reportstudio/models/ReportStudioTemplate';

export class ReportStudioExportConfig extends ExportServerConfig {
  /**
   * @type {{}}
   */
  report;

  constructor(model = {}) {
    super(model);

    this.report = new ReportStudioTemplate(model.report) || {};
  }
}
